export default __webpack_public_path__ + "media/images/bordcell1-49bbd4988f90fc9dd328760d4badb15d.png";